module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_1_488d2314.8ccd53d2.eot";